import { normalizeLegacyAppFormsTreeIds } from 'app/services/autoLockForms/autoLockForms.utils';
import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { LOCKED_FIELDS_ACTION_TYPE } from '../actions';

const initialState = { lockedFieldIds: [], lockedPageIds: [] };

const lockedFieldsReducer = (state = initialState, { type, payload }) =>
  produce(state, () => {
    switch (type) {
      case LOCKED_FIELDS_ACTION_TYPE.GET_LOCKED_FIELDS:
        // Rules saved before LEN2-499 may carry the nameless Lead/Activities/Tasks ids.
        return {
          lockedFieldIds: normalizeLegacyAppFormsTreeIds(payload.lockedFieldIds || []),
          lockedPageIds: normalizeLegacyAppFormsTreeIds(payload.lockedPageIds || []),
        };

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default lockedFieldsReducer;
